import React, { useEffect, useState } from 'react';
import { FiSearch, FiX, FiTrash2, FiEye, FiMail } from 'react-icons/fi';
import API from '../utils/api';
import { toast } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import './AdminPages.css';

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [viewModal, setViewModal] = useState(null);

  const fetch = () => {
    setLoading(true);
    API.get('/api/admin/contacts')
      .then(r => setContacts(r.data.data))
      .catch(() => toast.error('Failed to load messages'))
      .finally(() => setLoading(false));
  };
  useEffect(fetch, []);

  const markRead = async (id) => {
    await API.put(`/api/admin/contacts/${id}`, { status: 'read' });
    fetch();
  };

  const markReplied = async (id) => {
    await API.put(`/api/admin/contacts/${id}`, { status: 'replied' });
    toast.success('Marked as replied');
    setViewModal(null);
    fetch();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this message?')) return;
    await API.delete(`/api/admin/contacts/${id}`);
    toast.success('Deleted');
    setViewModal(null);
    fetch();
  };

  const openView = async (c) => {
    setViewModal(c);
    if (c.status === 'new') markRead(c._id);
  };

  const filtered = contacts.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase()) ||
    c.subject?.toLowerCase().includes(search.toLowerCase())
  );

  const newCount = contacts.filter(c => c.status === 'new').length;

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h2>Messages</h2>
          <p>{contacts.length} total · <strong style={{ color:'var(--primary)' }}>{newCount} unread</strong></p>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <div className="admin-filters" style={{ margin:0 }}>
            <div className="admin-search">
              <FiSearch />
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search messages..." />
              {search && <button style={{ position:'absolute',right:10,background:'none',border:'none',cursor:'pointer' }} onClick={() => setSearch('')}><FiX /></button>}
            </div>
          </div>
        </div>
        <div className="admin-table-wrap">
          {loading ? <div className="spinner" style={{ margin:'40px auto' }} /> : (
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Email</th><th>Phone</th><th>Subject</th><th>Date</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.length > 0 ? filtered.map(c => (
                  <tr key={c._id} style={{ fontWeight: c.status==='new' ? 600 : 400 }}>
                    <td>{c.name}</td>
                    <td>{c.email}</td>
                    <td>{c.phone || '—'}</td>
                    <td style={{ maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.subject}</td>
                    <td>{new Date(c.createdAt).toLocaleDateString('en-IN', { day:'numeric', month:'short' })}</td>
                    <td><span className={`badge-status ${c.status}`}>{c.status}</span></td>
                    <td>
                      <div className="action-btns">
                        <button className="btn-action view" onClick={() => openView(c)} title="View"><FiEye /></button>
                        <button className="btn-action delete" onClick={() => handleDelete(c._id)} title="Delete"><FiTrash2 /></button>
                      </div>
                    </td>
                  </tr>
                )) : <tr><td colSpan={7}><div className="admin-empty">No messages found</div></td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <AnimatePresence>
        {viewModal && (
          <motion.div className="admin-modal-overlay" initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }} onClick={e => e.target === e.currentTarget && setViewModal(null)}>
            <motion.div className="admin-modal" initial={{ scale:0.9 }} animate={{ scale:1 }} exit={{ scale:0.9 }}>
              <div className="admin-modal-header">
                <h3>{viewModal.subject}</h3>
                <button className="admin-modal-close" onClick={() => setViewModal(null)}><FiX /></button>
              </div>
              <div className="admin-modal-body">
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:16 }}>
                  <div><label style={{ fontSize:'0.75rem', color:'var(--text-light)', display:'block' }}>From</label><strong>{viewModal.name}</strong></div>
                  <div><label style={{ fontSize:'0.75rem', color:'var(--text-light)', display:'block' }}>Email</label><a href={`mailto:${viewModal.email}`}>{viewModal.email}</a></div>
                  {viewModal.phone && <div><label style={{ fontSize:'0.75rem', color:'var(--text-light)', display:'block' }}>Phone</label><a href={`tel:${viewModal.phone}`}>{viewModal.phone}</a></div>}
                  <div><label style={{ fontSize:'0.75rem', color:'var(--text-light)', display:'block' }}>Date</label>{new Date(viewModal.createdAt).toLocaleString('en-IN')}</div>
                </div>
                <div style={{ background:'#f8fafc', borderRadius:10, padding:16, lineHeight:1.7, fontSize:'0.9rem' }}>{viewModal.message}</div>
              </div>
              <div className="admin-modal-footer">
                <button className="btn-admin-danger" onClick={() => handleDelete(viewModal._id)}>Delete</button>
                <a href={`mailto:${viewModal.email}?subject=Re: ${viewModal.subject}`} className="btn-admin-primary" style={{ display:'inline-flex', alignItems:'center', gap:6, textDecoration:'none' }} onClick={() => markReplied(viewModal._id)}>
                  <FiMail /> Reply via Email
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
